import React, { useEffect, useState } from "react";
import { ModalBody } from "@vds/modals";
import { Loader } from "@vds/loaders";
import { TextArea } from "@vds/inputs";
import styled from "styled-components";
import { connect } from "react-redux";
import * as Actions from "../../store/actions/cases/allCasesActions";
import * as CreateCaseActions from "../../store/actions/cases/createCaseActions";
import AddAttachmentImpl from "./AddAttachmentImpl";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import {
  CPButton,
  CustomisedTertiaryButton,
  CustomisedTextLink,
  CustomisedTitle,
  FlexColumn,
  FlexRow,
  Wrapper,
  TextWrapper as Textwrapper,
  FullScreenModalButtonWrapper,
  CustomisedBackPath,
  ModalBox,
} from "../../constants/common/StyledGlobalConstants";
import { helpNavigationHandler } from "../../util/helpURLNavigation";
import LoseUnsavedChanges from "./LoseUnsavedChanges";
import BackPath from "../../assets/icons/back-path.png";
import { Title } from "@vds/typography";
import { Line } from "@vds/lines";
import CPNotification from "../../pages/Login/CPNotification";
import RedesignedInput from "../common/RedesignedInput";
import { DEVICE_BREAKPOINTS } from "../../constants/appConstants";
import PropTypes from "prop-types";

const { TABLET, DESKTOP } = DEVICE_BREAKPOINTS;

const NameRegex = /^[a-zA-Z'’]+( [a-zA-Z'’]+)*$/;
const TextWrapper = styled.p`
  font-family: "neue-haas-grotesk-text";
  font-style: normal;
  font-weight: 400;
  font-size: ${(props) => (props.fontSize ? props.fontSize : "")};
  color: ${(props) => (props.fontColor ? props.fontColor : "")};
  line-height: 20px;
  margin: 0;
  display: inherit;
`;

const TextAreaWrapper = styled.div`
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  & div {
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : "")};
  }
  & label {
    & p {
      & span {
        display: ${(props) => (props.hideOptional ? props.hideOptional : "")};
      }
    }
  }
`;

const CustomisedTextArea = styled(TextArea)`
  font-family: "neue-haas-grotesk-text";
  font-size: 14px;
  max-width: 100%;
`;

const Required = styled.span`
  color: #0077b4 !important;
  font-size: 14px !important;
  margin: ${(props) => (props.margin ? props.margin : "")};
`;

function CreateNewCase(props) {
  const [detailsFieldLength] = useState(1000);
  const [newCasefilesWithInvalidFilename, setNewCasefilesWithInvalidFilename] = useState(false);
  const { t } = useTranslation("casesTranslation");

  useEffect(() => {
    return () => window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    props.setCreateCaseFields(
      "helpCenterLink",
      helpNavigationHandler(props.regionId, "Customer Portal | Support Cases | Help ", props.accountNumber, true, true)
    );
    props.setCreateCaseFields("caseContact", props.fullName);
    //if the name is Default Admin, set the error for case contact field
    if (props.fullName.toLowerCase() === "default admin") {
      props.setCreateCaseFieldsErr("caseContactErr", true);
    }
    splitNameBasedOnSpace(props.fullName);
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        props.toggleCreateCase(false);
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => {
      props.reset();
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);

  useEffect(() => {
    if (
      props.caseContactErr !== true &&
      props.subject &&
      props.details &&
      ((props.type !== "3G Migration RMA" && props.specificType) || props.type === "3G Migration RMA")
    ) {
      props.setSubmitButton(false);
    } else if (!props.disableSubmit) {
      props.setSubmitButton(true);
    }
  }, [props.type, props.specificType, props.subject, props.details, props.caseContact]);

  //Split the name based on Spaces in the word, last space in the word and the following words should be assigned to Surname, remaining to firstName
  // if there is only one word in the name, assign it to surname and make firstName as empty
  const splitNameBasedOnSpace = (name) => {
    let modifiedFirstName, modifiedSurName;
    const lastSpaceIndex = name.lastIndexOf(" ");
    if (lastSpaceIndex !== -1) {
      modifiedFirstName = name.substring(0, lastSpaceIndex);
      modifiedSurName = name.substring(lastSpaceIndex + 1);
    } else {
      modifiedFirstName = "";
      modifiedSurName = name;
    }
    props.setCreateCaseFields("lastName", modifiedSurName);
    props.setCreateCaseFields("firstName", modifiedFirstName);
  };

  const checkIfNameMatches = (fullName) => {
    let userFullName = "default admin";
    const regex = new RegExp(`^${userFullName}$`);
    return regex.test(fullName.toLowerCase());
  };

  const handleFields = (field, value) => {
    if (!shouldSkipDetailsField(field, value)) {
      if (field === "caseContact") {
        handleCaseContact(value);
      }
      props.setCreateCaseFields(field, value);
    }
    if (field === "type") {
      handleTypeChange(value);
    }
    if (props.mandatoryFields.includes(field)) {
      validateMandatoryField(field, value);
    }
  };

  // ==== Helper Functions ====

  const shouldSkipDetailsField = (field, value) => {
    return field === "details" && value.length > detailsFieldLength;
  };

  const handleCaseContact = (value) => {
    const val = value.toLowerCase();
    if (val !== "default admin" && val !== "defaultadmin" && val !== "") {
      splitNameBasedOnSpace(value);
    }
  };

  const handleTypeChange = (value) => {
    props.setCreateCaseFields("specificType", "");
    if (value !== "3G Migration RMA") {
      props.getSpecificTypeArr();
    } else {
      if (props.cancelDisable) {
        props.setCancelDisable(false);
      }
      props.setSpecificTypeArr([]);
    }
  };

  const validateMandatoryField = (field, value) => {
    const errField = `${field}Err`;
    const isInvalidContact =
      field === "caseContact" &&
      (!value || !NameRegex.test(value) || value.toLowerCase() === "default admin" || value.toLowerCase() === "defaultadmin");

    const isInvalidGeneral = !value;

    const shouldSetError = (field === "caseContact" && isInvalidContact) || (field !== "caseContact" && isInvalidGeneral);

    if (shouldSetError && !props[errField]) {
      props.setCreateCaseFieldsErr(errField, true);
    } else if (!shouldSetError && props[errField]) {
      props.setCreateCaseFieldsErr(errField, false);
    }
  };

  const handleCancel = () => {
    newCasefilesWithInvalidFilename && setNewCasefilesWithInvalidFilename(false);
    if (props.cancelDisable && !props.type && !props.specificType && !props.subject && !props.details) {
      props.toggleCreateCase(false);
    } else if (
      props.esn !== "" ||
      props.vin !== "" ||
      props.vehicleLabel !== "" ||
      props.subject !== "" ||
      props.details !== "" ||
      props.invoiceNo !== "" ||
      props.type ||
      props.specificType ||
      props.contractAcc ||
      props.attachmentCheck
    ) {
      props.toggleCancelCase(true);
    } else {
      props.toggleCreateCase(false);
    }
  };

  const handleSpecificTypeTryAgain = () => {
    props.getSpecificTypeArr();
  };

  const handleSubmit = () => {
    newCasefilesWithInvalidFilename && setNewCasefilesWithInvalidFilename(false);
    props.createNewCase();
  };

  const labelStyle = {
    fontWeight: "700",
    fontSize: "12px",
    lineHeight: "48px",
  };

  const getBackgroundColor = (state, type) => {
    switch (type) {
      case "control":
        if (state.isDisabled) return "#f0f0f0";
        if (state.isFocused) return "var(--background-secondary, #F6F6F6)";
        return "#fff";
      case "option":
        if (state.isFocused) return "#0000000D";
        if (state.isSelected) return "var(--background-secondary, #F6F6F6)";
        return "transparent";
      default:
        return "";
    }
  };

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      width: "100%",
      height: "2.75rem",
      border: state.isFocused ? "2px solid var(--feedback-information, #006FC1)" : "1px solid #d8dada",
      borderRadius: "4px",
      fontSize: "0.875rem",
      fontFamily: '"neue-haas-grotesk-text"',
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      flexWrap: "nowrap",
      boxShadow: "none",
      color: state.isDisabled ? "#999" : "#000",
      backgroundColor: getBackgroundColor(state, "control"),
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "0.875rem",
      fontFamily: '"neue-haas-grotesk-text"',
      color: "#000",
    }),
    menu: (base) => ({
      ...base,
      width: "100%",
      zIndex: 9999,
      backgroundColor: "#fff",
      border: "1px solid #d8dada",
      borderRadius: "4px",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    }),
    option: (base, state) => ({
      ...base,
      paddingTop: "14px",
      paddingRight: "16px",
      paddingBottom: "14px",
      paddingLeft: "16px",
      gap: "10px",
      fontSize: "0.875rem",
      fontWeight: 400,
      fontFamily: '"neue-haas-grotesk-text"',
      color: "#000",
      backgroundColor: getBackgroundColor(state, "option"),
      cursor: "pointer",
      padding: "0.5rem",
      borderLeft: state.isSelected ? "4px solid #EE0000" : "4px solid transparent",
      "&:active": {
        backgroundColor: "#0000001F",
      },
    }),
  };

  const typeOptions = props.typeArr.sort().map((val) => ({
    value: val,
    label: t(val),
  }));
  if (props.firstoption) {
    typeOptions.unshift({
      value: "",
      label: t("Select type"),
      isdisabled: true,
    });
  }

  const specificTypeOptions = props.specificTypeArr.sort().map((item) => ({
    value: item.value,
    label: t(item.label),
  }));
  if (props.firstoption) {
    specificTypeOptions.unshift({
      value: "",
      label: t("Select specific type"),
      isdisabled: true,
    });
  }
  const getColumWidth = () => (props.windowSize.width < TABLET ? "100%" : "50%");
  const getMarginTop = () => (props.windowSize.width < DESKTOP ? "1rem" : "1.5rem");

  return (
    <>
      <style>
        {`
      a:focus {
     border-radius: 2px;
     border: 2px solid #006fc1;
      }
      `}
      </style>
      <ModalBox
        opened={props.createCaseToggle}
        aria-label="Create Case Modal"
        id="cp-modal"
        closeButton={
          <>
            <Wrapper
              style={{
                display: "flex",
                padding: `${props.windowSize.width >= DESKTOP ? "24px 0 24px 0" : "16px 0 16px 0"}`,
                alignItems: "center",
              }}
              onClick={(event) => event.preventDefault()}
            >
              <CustomisedBackPath
                src={BackPath}
                onClick={handleCancel}
                userLanguage={props.userLanguage}
                windowSize={props.windowSize.width}
                tabIndex="0"
                aria-label="Back"
              />
              <CustomisedTitle fontSize={"24px"} lineHeight="32px" style={{ margin: "0" }}>
                <Title size="large">{t("Support cases")}</Title>
              </CustomisedTitle>
            </Wrapper>
            {<Line type="xLight" inverted={false} />}
          </>
        }
        fullScreenDialog={true}
        disableOutsideClick={true}
      >
        <ModalBody
          style={{
            padding: `${props.windowSize.width < DESKTOP ? "0 1rem" : "0"}`,
            marginBottom: "3rem",
            minHeight: "calc(100vh-70px)",
            paddingBottom: "100px",
          }}
        >
          <div id="cp-modal-body">
            <Loader active={props.isLoading} fullscreen={true} />
            <Wrapper display="flex" justifyContent="center" paddingLeft="12px">
              <FlexColumn width={props.windowSize.width < DESKTOP ? "100%" : "60%"}>
                <FlexRow marginLeft="0">
                  <CustomisedTitle
                    fontSize="40px"
                    lineHeight="48px"
                    style={{ margin: `${props.windowSize.width < DESKTOP ? "24px 0 0 0" : "48px 0 0 0"}` }}
                  >
                    <Title aria-label="Create new case" size="large">
                      {t("Create new case")}
                    </Title>
                  </CustomisedTitle>
                </FlexRow>
                {props.newCaseErr && (
                  <FlexRow marginLeft="0" marginTop="24px">
                    <CPNotification isOpen={props.newCaseErr} notificationType="error" height="auto" width="100%">
                      <Wrapper fontFamily="neue-haas-grotesk-text" fontSize="0.875rem">
                        {t("Failed to create a case. Try again later or contact support.")}
                      </Wrapper>
                    </CPNotification>
                  </FlexRow>
                )}
                <FlexRow marginLeft="0" marginTop="24px" marginBottom="24px">
                  <CPNotification isOpen={true} notificationType="info" height="auto" width="100%">
                    <Wrapper fontFamily="neue-haas-grotesk-text" fontSize="0.875rem">
                      {t("Before creating a new case, search the")}{" "}
                      <a
                        id="refresh-page-link"
                        tabIndex="0"
                        type="standAlone"
                        size="large"
                        href={"https://reveal-help.verizonconnect.com/hc/"}
                        aria-label="help center"
                        target="_blank"
                        style={{ fontFamily: "neue-haas-grotesk-text", fontSize: "0.875rem", color: "black" }}
                      >
                        {t("help center")}
                      </a>{" "}
                      {t("to find information to help solve your query.")}
                    </Wrapper>
                  </CPNotification>
                </FlexRow>
                <FlexRow marginLeft="0">
                  <TextWrapper aria-label="Mandatory fields" fontSize={"14px"} fontColor={"black"}>
                    {
                      <>
                        {<Required margin="0 5px 0 0">*</Required>}
                        {" - "}
                        {t("Mandatory fields")}
                      </>
                    }
                  </TextWrapper>
                </FlexRow>
                <RedesignedInput
                  id="contact-input"
                  label={t("Case contact")}
                  isRequired={true}
                  ariaLabel="Case Contact"
                  error={props.caseContactErr}
                  errorText={t("Case contact is invalid")}
                  isDisabled={!checkIfNameMatches(props.fullName)}
                  value={props.caseContact}
                  width="100%"
                  marginTop={getMarginTop()}
                  handleOnChange={(value) => handleFields("caseContact", value)}
                />
                <FlexRow>
                  <FlexColumn width={getColumWidth()} paddingRight={props.windowSize.width >= TABLET && "1.5rem"}>
                    <div>
                      <label htmlFor="type-dropdown" aria-label={t("Type")} style={labelStyle}>
                        {t("Type")}
                        <span aria-hidden="true" style={{ color: "#0077b4", fontSize: "14px", padding: "5px" }}>
                          *
                        </span>
                      </label>
                    </div>
                    <Select
                      aria-label="type required"
                      id="dropdown-filter"
                      inputId="type-dropdown"
                      options={typeOptions}
                      value={typeOptions.find((opt) => opt.value === props.type || null)}
                      onChange={(selectedoption) => handleFields("type", selectedoption?.value)}
                      placeholder={t(`Select type`)}
                      classNamePrefix={props.typeErr ? "react-select-error" : "react-select"}
                      styles={selectStyles}
                    />
                  </FlexColumn>
                  <FlexColumn width={getColumWidth()}>
                    <div>
                      <label htmlFor="specific-type-dropdown-input" style={labelStyle}>
                        {t("Specific type")}
                        <span aria-hidden="true" style={{ color: "#0077b4", fontSize: "14px", padding: "5px" }}>
                          *
                        </span>
                      </label>
                    </div>
                    <Select
                      aria-label="specific type required"
                      id="specific-type-dropdown"
                      inputId="specific-type-dropdown-input"
                      options={specificTypeOptions}
                      value={props.specificType ? specificTypeOptions.find((opt) => opt.value === props.specificType) : null}
                      onChange={(selectedoption) => handleFields("specificType", selectedoption?.value)}
                      placeholder={t("Select specific type")}
                      isDisabled={!props.specificTypeArr.length || props.disableFields}
                      classNamePrefix={props.specificTypeErr ? "react-select-error" : "react-select"}
                      styles={selectStyles}
                    />
                    {props.specificTypeErr && <div style={{ color: "red" }}>{t("Please select a specific type")}</div>}
                  </FlexColumn>
                </FlexRow>
                {props.specificTypeArr.length === 0 && props.type !== "" && props.type !== "3G Migration RMA" && (
                  <CustomisedTextLink
                    id="tryagain-casereason"
                    fontSize="0.875rem"
                    width="fit-content"
                    marginTop={getMarginTop()}
                    lineHeight="14px"
                    type="inline"
                    className="textLink-el"
                    onClick={handleSpecificTypeTryAgain}
                    style={{ placeSelf: "auto" }}
                  >
                    {t("Try again")}
                  </CustomisedTextLink>
                )}
                {props.type === "Finance / Contractual" && (
                  <>
                    <Wrapper>
                      <RedesignedInput
                        id="contract-account-number-dropdown"
                        label={t("Contract account number")}
                        isRequired={false}
                        ariaLabel="Contract account number"
                        isDisabled={true}
                        value={props.contractAcc}
                        width="100%"
                        marginTop={getMarginTop()}
                      />
                    </Wrapper>
                    <Wrapper>
                      <RedesignedInput
                        id="invoice-number-input"
                        label={t("Invoice number")}
                        isRequired={false}
                        maxLength="12"
                        ariaLabel="Invoice number"
                        isDisabled={props.disableFields}
                        value={props.invoiceNo}
                        handleOnChange={(value) => handleFields("invoiceNo", value)}
                        width="100%"
                        marginTop={getMarginTop()}
                      />
                    </Wrapper>
                  </>
                )}
                {props.type === "Hardware" && (
                  <>
                    <Wrapper>
                      <RedesignedInput
                        id="esn-input"
                        label={t("ESN")}
                        isRequired={false}
                        maxLength="255"
                        ariaLabel="ESN"
                        isDisabled={props.disableFields}
                        value={props.esn}
                        handleOnChange={(value) => handleFields("esn", value)}
                        width="100%"
                        marginTop={getMarginTop()}
                      />
                    </Wrapper>
                    <Wrapper>
                      <RedesignedInput
                        id="vin-input"
                        label={t("VIN")}
                        isRequired={false}
                        maxLength="17"
                        ariaLabel="VIN"
                        isDisabled={props.disableFields}
                        value={props.vin}
                        handleOnChange={(value) => handleFields("vin", value)}
                        width="100%"
                        marginTop={getMarginTop()}
                      />
                    </Wrapper>
                    <Wrapper>
                      <RedesignedInput
                        id="vehicle-label-input"
                        label={t("Vehicle name")}
                        isRequired={false}
                        maxLength="200"
                        ariaLabel="Vehicle name"
                        isDisabled={props.disableFields}
                        value={props.vehicleLabel}
                        handleOnChange={(value) => handleFields("vehicleLabel", value)}
                        width="100%"
                        marginTop={getMarginTop()}
                      />
                    </Wrapper>
                  </>
                )}
                <RedesignedInput
                  id="subject-input"
                  label={t("Subject")}
                  isRequired={true}
                  maxLength="255"
                  ariaLabel="Subject"
                  isDisabled={props.disableFields}
                  value={props.subject}
                  handleOnChange={(value) => handleFields("subject", value)}
                  width="100%"
                  marginTop={getMarginTop()}
                  error={props.subjectErr}
                  errorText={t("Please enter the subject")}
                />

                <TextAreaWrapper marginTop={getMarginTop()} hideOptional="none" maxWidth="100%">
                  <CustomisedTextArea
                    id="detatils-textarea"
                    label={t("Details")}
                    aria-label="Details"
                    required={false}
                    error={props.detailsErr}
                    errorEvent="blurAndChange"
                    value={props.details}
                    disabled={props.disableFields}
                    onChange={(event) => handleFields("details", event.target.value)}
                    maxLength={detailsFieldLength}
                  />
                </TextAreaWrapper>
                <TextWrapper
                  fontSize={"12px"}
                  fontColor={"#747474"}
                  style={{ "margin-left": "0", "margin-top": `${props.windowSize.width < DESKTOP ? "4px" : "8px"}` }}
                >
                  {t("Enter Character", { number: `${detailsFieldLength}` })}
                </TextWrapper>
                {newCasefilesWithInvalidFilename && (
                  <Wrapper marginTop="1rem">
                    <CPNotification notificationType="error" isOpen={true} width="auto" height="auto">
                      <Wrapper fontSize="0.875rem" fontFamily="neue-haas-grotesk-text">
                        <Textwrapper fontWeight="bold" aria-label="The file name contains special characters">
                          {t("The file name contains special characters")}
                        </Textwrapper>
                        <Textwrapper
                          aria-label="The name of the selected file contains special characters and cannot be uploaded."
                          margin="0.7rem 0rem 0rem 0rem"
                        >
                          {t("The name of the selected file contains special characters and cannot be uploaded.")}
                        </Textwrapper>
                        <Textwrapper aria-label="Rename the file using letters, numbers and the following characters only !-_.'()">
                          {t("Rename the file using letters, numbers and the following characters only !-_.'()")}
                        </Textwrapper>
                      </Wrapper>
                    </CPNotification>
                  </Wrapper>
                )}
                <div style={{ "margin-top": `${props.windowSize.width < DESKTOP ? "16px" : "24px"}`, "margin-left": "0" }}>
                  <AddAttachmentImpl
                    filesWithInvalidFilename={newCasefilesWithInvalidFilename}
                    setFilesWithInvalidFilename={setNewCasefilesWithInvalidFilename}
                  />
                </div>
              </FlexColumn>
            </Wrapper>
          </div>
        </ModalBody>
        <footer
          className="sticky-bottom-footer"
          style={{
            position: "fixed",
            bottom: "0",
            height: "70px",
            width: "100%",
          }}
          id="cp-modal-body-footer"
        >
          <Line type="xLight" inverted={false} />
          <FullScreenModalButtonWrapper>
            <CustomisedTertiaryButton
              aria-label="Cancel"
              onClick={handleCancel}
              disabled={props.cancelDisable}
              buttonWidth={props.windowSize.width < TABLET ? "100%" : "autoTight"}
            >
              {t("CANCEL")}
            </CustomisedTertiaryButton>
            <CPButton
              width={props.windowSize.width < TABLET ? "100%" : "autoTight"}
              buttonHeight={"40px"}
              fontSize="0.875rem"
              boxButton={true}
              disabled={props.disableSubmit}
              onClick={handleSubmit}
              aria-label="Submit"
              fontPaddingLeft={props.windowSize.width >= TABLET && "0.75rem"}
              fontPaddingRight={props.windowSize.width >= TABLET && "0.75rem"}
              style={{
                height: "2.5rem",
              }}
            >
              {t("SUBMIT")}
            </CPButton>
          </FullScreenModalButtonWrapper>
        </footer>
      </ModalBox>
      {props.cancelCaseToggle && (
        <LoseUnsavedChanges
          open={props.cancelCaseToggle}
          onClose={() => props.toggleCancelCase(false)}
          yesButtonId="create-new-case-lose-change-yes-button"
          noButtonId="create-new-case-lose-change-no-button"
          onYesButtonClick={() => {
            props.toggleCancelCase(false);
            props.toggleCreateCase(false);
          }}
          windowSize={props.windowSize}
        />
      )}
    </>
  );
}
const mapDispatchToProps = {
  toggleCreateCase: Actions.toggleCreateCase,
  setTypeArr: CreateCaseActions.setTypeArr,
  setCreateCaseFields: CreateCaseActions.setCreateCaseFields,
  setSpecificTypeArr: CreateCaseActions.setSpecificTypeArr,
  getTypeArr: CreateCaseActions.getTypeArr,
  getSpecificTypeArr: CreateCaseActions.getSpecificTypeArr,
  setCreateCaseFieldsErr: CreateCaseActions.setCreateCaseFieldsErr,
  setSubmitButton: CreateCaseActions.setSubmitButton,
  setCancelDisable: CreateCaseActions.setCancelDisable,
  setModalOpen: CreateCaseActions.setModalOpen,
  toggleCancelCase: CreateCaseActions.toggleCancelCase,
  createNewCase: CreateCaseActions.createNewCase,
  setSubmitAttachemnt: CreateCaseActions.setSubmitAttachment,
  setAttachemntFileNameError: CreateCaseActions.setAttchmentErrorNotification,
  setAttachmentSizeError: CreateCaseActions.setAttachmentFileSizeError,
  reset: CreateCaseActions.reset,
};
const mapStateToProps = (state) => {
  return {
    fullName: state.ACCOUNT.fullName,
    firstName: state.ACCOUNT.firstName,
    surname: state.ACCOUNT.surname,
    regionId: state.ACCOUNT.regionId,
    accountNumber: state.ACCOUNT.accountNumber,
    createCaseToggle: state.CASELIST.createCaseToggle,
    contractAccounts: state.CREATECASE.contractAccounts,
    isLoading: state.CREATECASE.isLoading,
    caseContact: state.CREATECASE.caseContact,
    type: state.CREATECASE.type,
    specificType: state.CREATECASE.specificType,
    subject: state.CREATECASE.subject,
    details: state.CREATECASE.details,
    contractAcc: state.CREATECASE.contractAcc,
    invoiceNo: state.CREATECASE.invoiceNo,
    esn: state.CREATECASE.esn,
    vin: state.CREATECASE.vin,
    vehicleLabel: state.CREATECASE.vehicleLabel,
    mandatoryFields: state.CREATECASE.mandatoryFields,
    helpCenterLink: state.CREATECASE.helpCenterLink,
    typeArr: state.CREATECASE.typeArr,
    specificTypeArr: state.CREATECASE.specificTypeArr,
    caseContactErr: state.CREATECASE.caseContactErr,
    typeErr: state.CREATECASE.typeErr,
    specificTypeErr: state.CREATECASE.specificTypeErr,
    subjectErr: state.CREATECASE.subjectErr,
    detailsErr: state.CREATECASE.detailsErr,
    newCaseErr: state.CREATECASE.newCaseErr,
    isModalOpen: state.CREATECASE.isModalOpen,
    cancelCaseToggle: state.CREATECASE.cancelCaseToggle,
    disableSubmit: state.CREATECASE.disableSubmit,
    handleAttachemntSubmit: state.CREATECASE.handleAttachemntSubmit,
    attachmentErrorNotification: state.CREATECASE.attachmentErrorNotification,
    attachmentFileSizeError: state.CREATECASE.attachmentFileSizeError,
    attachmentLoader: state.CREATECASE.attachmentLoader,
    attachmentCheck: state.CREATECASE.attachmentCheck,
    cancelDisable: state.CREATECASE.cancelDisable,
    disableFields: state.CREATECASE.disableFields,
    windowSize: state.ACCOUNT.windowSize,
  };
};

CreateNewCase.propTypes = {
  windowSize: PropTypes.shape({
    width: PropTypes.number,
  }),
  setCreateCaseFields: PropTypes.func.isRequired,
  setCreateCaseFieldsErr: PropTypes.func.isRequired,
  regionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  accountNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  specificType: PropTypes.string,
  fullName: PropTypes.string,
  caseContact: PropTypes.string,
  reset: PropTypes.func.isRequired,
  toggleCreateCase: PropTypes.func.isRequired,
  createCaseToggle: PropTypes.bool,
  caseContactErr: PropTypes.bool,
  subject: PropTypes.string,
  type: PropTypes.string,
  details: PropTypes.string,
  setSubmitButton: PropTypes.func.isRequired,
  mandatoryFields: PropTypes.array,
  disableSubmit: PropTypes.bool,
  getSpecificTypeArr: PropTypes.func.isRequired,
  setSpecificTypeArr: PropTypes.func.isRequired,
  cancelDisable: PropTypes.bool,
  setCancelDisable: PropTypes.func.isRequired,
  esn: PropTypes.string,
  vin: PropTypes.string,
  vehicleLabel: PropTypes.string,
  invoiceNo: PropTypes.string,
  contractAcc: PropTypes.string,
  toggleCancelCase: PropTypes.func.isRequired,
  cancelCaseToggle: PropTypes.bool,
  detailsErr: PropTypes.bool,
  subjectErr: PropTypes.bool,
  disableFields: PropTypes.bool,
  attachmentCheck: PropTypes.bool,
  createNewCase: PropTypes.func.isRequired,
  firstoption: PropTypes.bool,
  typeArr: PropTypes.array,
  specificTypeArr: PropTypes.array,
  isLoading: PropTypes.bool,
  newCaseErr: PropTypes.bool,
  specificTypeErr: PropTypes.bool,
  typeErr: PropTypes.bool,
  userLanguage: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewCase);
